<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef" class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">Stan pojazdu i dane dodatkowe</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">
                <div class="col-12 col-md-3">
                    <label class="form-label">Polisa OC</label>
                    <select class="form-select" v-model="form.ocState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">Kluczyki</label>
                    <select class="form-select" v-model="form.keysState">
                        <option value="">Wybierz...</option>
                        <option value="1">1 szt.</option>
                        <option value="2">2 szt.</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">Dowód rejestracyjny</label>
                    <select class="form-select" v-model="form.regBookState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                <!-- 
                <div class="col-12 col-md-3">
                    <label class="form-label">Naklejka rejestracyjna</label>
                    <select class="form-select" v-model="form.regStickerState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                -->
                <div class="col-12 col-md-3">
                    <label class="form-label">Tablice rejestracyjne</label>
                    <select class="form-select" v-model="form.platesState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                <!--
                <div class="col-12 col-md-3">
                    <label class="form-label">Karta pojazdu</label>
                    <select class="form-select" v-model="form.carCardState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                -->
                <div class="col-12 col-md-3">
                    <label class="form-label">Dowód zapłaty akcyzy</label>
                    <select class="form-select" v-model="form.exciseTaxState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label">Książka serwisowa</label>
                    <select class="form-select" v-model="form.serviceBookState">
                        <option value="">Wybierz...</option>
                        <option value="tak">Tak</option>
                        <option value="nie">Nie</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="form-label">Wyposażenie dodatkowe</label>
                    <textarea class="form-control" rows="4" v-model="form.additionalEquipment" maxlength="6000"></textarea>
                </div>
                <div class="col-12 col-md-6">
                    <label class="form-label">Uwagi do stanu pojazdu</label>
                    <textarea class="form-control" rows="4" v-model="form.vehicleStateNotes" maxlength="6000"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'

const props = defineProps({ modelValue: { type: Object, required: true } })
const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; user-select: none; }
</style>